import { toast } from 'sonner';
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../services/apiError';
import { showErrorDialog } from '../context';

interface HandleApiErrorOptions {
    queryClient?: QueryClient;
    refetchKeys?: readonly unknown[][];
    fallback?: string;
}

export function handleApiError(error: unknown, opts: HandleApiErrorOptions = {}): boolean {
    if (!(error instanceof ApiError)) return false;

    const { queryClient, refetchKeys, fallback } = opts;

    switch (error.code) {
        case 'STORAGE_GENERATION_MISMATCH':
            toast.error('Projekt został zmieniony w innej karcie/sesji.', {
                description: 'Przeładuj, aby zobaczyć aktualny stan.',
                duration: 10000,
                action: {
                    label: 'Przeładuj',
                    onClick: () => {
                        if (queryClient && refetchKeys?.length) {
                            refetchKeys.forEach(k => queryClient.invalidateQueries({ queryKey: k }));
                        } else {
                            window.location.reload();
                        }
                    },
                },
            });
            return true;

        case 'PROJECT_INVALID_LAYERS':
            showErrorDialog({
                title: 'Nie można zapisać projektu',
                message: error.message,
            });
            return true;

        case 'STORAGE_OBJECT_NOT_FOUND':
            toast.error('Plik nie został znaleziony w magazynie.');
            return true;

        case 'STORAGE_LOCK_TIMEOUT':
            toast.warning('Inny użytkownik zapisuje projekt. Spróbuj ponownie.', {
                duration: 6000,
            });
            return true;

        case 'STORAGE_BACKEND_UNAVAILABLE':
            toast.error('Magazyn chwilowo niedostępny. Spróbuj ponownie później.');
            return true;
    }

    if (fallback) toast.error(fallback);
    return false;
}
